import { render } from "./DescriptionComponent.vue?vue&type=template&id=cd9966de&scoped=true"
import script from "./DescriptionComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionComponent.vue?vue&type=script&lang=js"

import "./DescriptionComponent.vue?vue&type=style&index=0&id=cd9966de&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9966de"]])

export default __exports__